// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._v564ybtr{transition:all .3s}
._zulpu2gc{gap:var(--ds-space-100,8px)}._154iidpf{top:0}
._19bvu2gc{padding-left:var(--ds-space-100,8px)}
._1bahusic{justify-content:right}
._1e0c1txw{display:flex}
._1n261q9c{flex-wrap:nowrap}
._1xi2idpf{right:0}
._2lx2vrvc{flex-direction:row}
._ca0qu2gc{padding-top:var(--ds-space-100,8px)}
._kqswstnw{position:absolute}
._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}
._tzy4idpf{opacity:0}
._tzy4kb7n{opacity:1}
._u5f3u2gc{padding-right:var(--ds-space-100,8px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-card/dist/esm/card/ui/actionsBar/actionsBarWrapper-compiled.compiled.css"],"names":[],"mappings":";AACA,WAAW,kBAAkB;AAC7B,WAAW,2BAA2B,CAAC,WAAW,KAAK;AACvD,WAAW,oCAAoC;AAC/C,WAAW,qBAAqB;AAChC,WAAW,YAAY;AACvB,WAAW,gBAAgB;AAC3B,WAAW,OAAO;AAClB,WAAW,kBAAkB;AAC7B,WAAW,mCAAmC;AAC9C,WAAW,iBAAiB;AAC5B,WAAW,sCAAsC;AACjD,WAAW,SAAS;AACpB,WAAW,SAAS;AACpB,WAAW,qCAAqC","sourcesContent":["\n._v564ybtr{transition:all .3s}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._154iidpf{top:0}\n._19bvu2gc{padding-left:var(--ds-space-100,8px)}\n._1bahusic{justify-content:right}\n._1e0c1txw{display:flex}\n._1n261q9c{flex-wrap:nowrap}\n._1xi2idpf{right:0}\n._2lx2vrvc{flex-direction:row}\n._ca0qu2gc{padding-top:var(--ds-space-100,8px)}\n._kqswstnw{position:absolute}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}\n._tzy4idpf{opacity:0}\n._tzy4kb7n{opacity:1}\n._u5f3u2gc{padding-right:var(--ds-space-100,8px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
